import { useRouter } from 'next/router';

export const usePrivacy = (): 'private' | 'public' => {
  const router = useRouter();
  const paths = router.pathname.split('/');
  if (paths[1] === 'notes') {
    return 'private';
  } else return 'public';
};
